<template>
    <div>
        <h6 class="">{{ $t(`${configId}.draw.title`) }}</h6>
        <hr class="mt-2" />
        <div class="row">
            <div class="col-sm-4">
                <MaterialSelect
                    :disabled="disabled"
                    class="city-form-group city-bg"
                    id="input-draw"
                    name="draw"
                    label="name"
                    :filterable="true"
                    :options="lists.onoff"
                    v-model.trim="form.status"
                    :reduce="option => option.code"
                    :data-vv-scope="vScope"
                    v-validate="'required'"
                    :inputClasses="[{'is-invalid': fnHasError('draw', vScope) }]"
                    :error=" fnFirstError('draw', vScope)"
                    :helpText="helpDraw.status">
                    {{ $t(`${configId}.draw.model.status`) }}
                </MaterialSelect>
            </div>
        </div>
    </div>
</template>

<script>
import ManagePrintElementMixin from '../mixins/ManagePrintElementMixin';

export default {
    name: 'ConfigDrawGeneral',
    mixins: [
        ManagePrintElementMixin
    ],
    props: {
        drawHelp: {
            type: Object,
        },
    },
    data() {
        return {
            form: {
                status: 0,
            },
        }
    },
    computed: {
        helpDraw() {
            return this.drawHelp ?? this.$t(`${this.configId}.draw.help`);
        },
    },
}
</script>